import type { ReactNode } from 'react';
import { useMemo } from 'react';
import { sanitizeCardHtml } from '../lib/sanitize';

/**
 * Conteúdo de um card.
 *
 * O HTML é higienizado a cada render, mas memorizado pelo texto de entrada —
 * sem isso, o `DOMParser` correria outra vez a cada tecla premida na caixa de
 * notas ao lado.
 */
export function CardHtml({
  html,
  className,
}: {
  html: string;
  className?: string;
}): ReactNode {
  const limpo = useMemo(() => sanitizeCardHtml(html), [html]);
  return (
    <div
      className={`mc-card-html ${className ?? ''}`}
      // eslint-disable-next-line react/no-danger -- passa por sanitizeCardHtml
      dangerouslySetInnerHTML={{ __html: limpo }}
    />
  );
}
